import React from 'react';
import ChallengeList from './ChallengeList'

function ChallengePage() {
    return (
        <ChallengeList />
    );
}

export default ChallengePage;